/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_next = /** @type {(inputs: {}) => string} */ () => {
	return `Další`
};

const da_next = /** @type {(inputs: {}) => string} */ () => {
	return `Næste`
};

const de_next = /** @type {(inputs: {}) => string} */ () => {
	return `Weiter`
};

const en_next = /** @type {(inputs: {}) => string} */ () => {
	return `Next`
};

const es_next = /** @type {(inputs: {}) => string} */ () => {
	return `Siguiente`
};

const fr_next = /** @type {(inputs: {}) => string} */ () => {
	return `Suivant`
};

const hu_next = /** @type {(inputs: {}) => string} */ () => {
	return `Következő`
};

const it_next = /** @type {(inputs: {}) => string} */ () => {
	return `Successivo`
};

const nl_next = /** @type {(inputs: {}) => string} */ () => {
	return `Volgende`
};

const pl_next = /** @type {(inputs: {}) => string} */ () => {
	return `Następny`
};

const pt_next = /** @type {(inputs: {}) => string} */ () => {
	return `Próximo`
};

const sv_next = /** @type {(inputs: {}) => string} */ () => {
	return `Nästa`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const next = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.next(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("next", locale)
	if (locale === "cs") return cs_next(inputs)
	if (locale === "da") return da_next(inputs)
	if (locale === "de") return de_next(inputs)
	if (locale === "en") return en_next(inputs)
	if (locale === "es") return es_next(inputs)
	if (locale === "fr") return fr_next(inputs)
	if (locale === "hu") return hu_next(inputs)
	if (locale === "it") return it_next(inputs)
	if (locale === "nl") return nl_next(inputs)
	if (locale === "pl") return pl_next(inputs)
	if (locale === "pt") return pt_next(inputs)
	return sv_next(inputs)
};